import sendForm from './modules/sendForm'
import scrollTop from './modules/scrollTop'
import bannerhome from './modules/banner-home'
// import popUp from './modules/popUp';
import swiper from './modules/swiper'
import play from './modules/play'
import select from './modules/select'
import simulator from './modules/simulator'
import qa from './modules/qa'
import mask from './modules/mask'
import aos from './modules/aos'
import header from './modules/header'
import loader from './modules/loader'
import whereFind from './modules/whereFind'
import languageChange from './modules/languageChange'

sendForm()
scrollTop()
bannerhome()
// popUp();
swiper()
play()
select()
simulator()
qa()
mask()
aos()
header()
loader()
whereFind()
languageChange()
